const styles = {
  LipsContainer: {
    height: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "0px",
  },
  LipsLogo: {
    height: "auto",
    borderRadius: "15px",
    border: "solid 0px",
    marginTop: "5px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "0px",
    cursor: "pointer",
  },
};

function NewTab() {
  window.open("https://testnet.binance.org/faucet-smart", "_blank");
}
function HashlipsLogo(props) {
  return (
    <div style={styles.LipsContainer}>
      <img
        style={styles.LipsLogo}
        src={props.image}
        alt="logo"
        onClick={() => NewTab()}
      />
    </div>
  );
}
export default HashlipsLogo;
